// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modern-toast {
  display: flex;
  flex-direction: column;
  width: calc(100% - 30px);
  min-width: 280px;
  max-width: 420px;
  border-radius: 12px;
  margin: 0;
  position: relative;
  overflow: hidden;
  z-index: 99999 !important;
  /* Premium Light-mode Professional base styling */
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 16px -6px rgba(0, 0, 0, 0.04);
  color: #1f2937 !important; /* Dark neutral gray for high-quality corporate readability */
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  /* Specific Action Styles (using subtle professional tints) */
}
.modern-toast.success {
  border-left: 4px solid #10b981;
}
.modern-toast.success .icon-wrap {
  background: #f0fdf4;
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.15);
}
.modern-toast.success .progress-fill {
  background: #10b981 !important;
}
.modern-toast.success .btn-ok {
  background: #10b981 !important;
  color: #ffffff !important;
  border: 1px solid #10b981 !important;
}
.modern-toast.success .btn-ok:hover {
  background: #059669 !important;
  border-color: #059669 !important;
}
.modern-toast.error, .modern-toast.delete {
  border-left: 4px solid #ef4444;
}
.modern-toast.error .icon-wrap, .modern-toast.delete .icon-wrap {
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.15);
}
.modern-toast.error .progress-fill, .modern-toast.delete .progress-fill {
  background: #ef4444 !important;
}
.modern-toast.error .btn-ok, .modern-toast.delete .btn-ok {
  background: #ef4444 !important;
  color: #ffffff !important;
  border: 1px solid #ef4444 !important;
}
.modern-toast.error .btn-ok:hover, .modern-toast.delete .btn-ok:hover {
  background: #dc2626 !important;
  border-color: #dc2626 !important;
}
.modern-toast.warning {
  border-left: 4px solid #f59e0b;
}
.modern-toast.warning .icon-wrap {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid rgba(245, 158, 11, 0.15);
}
.modern-toast.warning .progress-fill {
  background: #f59e0b !important;
}
.modern-toast.warning .btn-ok {
  background: #f59e0b !important;
  color: #ffffff !important;
  border: 1px solid #f59e0b !important;
}
.modern-toast.warning .btn-ok:hover {
  background: #d97706 !important;
  border-color: #d97706 !important;
}
.modern-toast.info, .modern-toast.update {
  border-left: 4px solid #3b82f6;
}
.modern-toast.info .icon-wrap, .modern-toast.update .icon-wrap {
  background: #eff6ff;
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.15);
}
.modern-toast.info .progress-fill, .modern-toast.update .progress-fill {
  background: #3b82f6 !important;
}
.modern-toast.info .btn-ok, .modern-toast.update .btn-ok {
  background: #3b82f6 !important;
  color: #ffffff !important;
  border: 1px solid #3b82f6 !important;
}
.modern-toast.info .btn-ok:hover, .modern-toast.update .btn-ok:hover {
  background: #2563eb !important;
  border-color: #2563eb !important;
}

/* Glass Overlay gives a premium glossy sheen */
.glass-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
  z-index: 1;
}

.toast-body {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 14px; /* Reduced mobile height to prevent scroll and look neat */
  position: relative;
  z-index: 2;
}
@media (min-width: 768px) {
  .toast-body {
    padding: 12px 16px;
  }
}

.icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  backdrop-filter: blur(5px);
  flex-shrink: 0;
}

.icon-wrap ion-icon {
  font-size: 18px;
  opacity: 0;
  transform: scale(0.5) rotate(-30deg);
  animation-fill-mode: forwards;
}

/* Icon entry animation */
@keyframes modernIconPop {
  0% {
    opacity: 0;
    transform: scale(0.5) rotate(-30deg);
  }
  60% {
    opacity: 1;
    transform: scale(1.15) rotate(10deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}
.icon-wrap.animated ion-icon {
  animation: modernIconPop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

.message-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.message-text {
  font-size: 0.92rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.1px;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.btn-ok {
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f3f4f6;
  color: #374151;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 6px;
  min-width: 48px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-ok:hover {
  background: #e5e7eb;
  color: #111827;
  transform: translateY(-1px);
}

.btn-close {
  border: none;
  background: transparent;
  color: #4b5563; /* Darker gray for high visibility */
  font-size: 1.25rem;
  width: 26px;
  height: 26px;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.btn-close:hover {
  background: #f3f4f6; /* Subtle circular indicator on hover */
  color: #111827;
}

/* Subtle Progress Bar */
.modern-progress-bar {
  height: 3px;
  width: 100%;
  background: rgba(0, 0, 0, 0.04);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
}

.progress-fill {
  height: 100%;
  width: 100%;
  border-radius: 0 4px 4px 0;
  transition: width 50ms linear;
}

/* --- Positioning & Animations --- */
/* Desktop top-right */
.top-right {
  position: fixed;
  top: 25px;
  right: 25px;
  animation: slideRightBounce 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

/* Mobile top-center */
.top {
  position: fixed;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  animation: slideTopBounce 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

/* Closing animations */
.modern-toast.closing.top-right {
  animation: fadeOutRight 0.3s forwards ease-in;
}

.modern-toast.closing.top {
  animation: fadeOutUp 0.3s forwards ease-in;
}

/* Slide in */
@keyframes slideRightBounce {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideTopBounce {
  0% {
    opacity: 0;
    transform: translate(-50%, -50px);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
/* Slide out */
@keyframes fadeOutRight {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes fadeOutUp {
  0% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/fancy-toast/fancy-toast.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EAEA,iDAAA;EACA,mBAAA;EACA,qCAAA;EACA,qFAAA;EACA,yBAAA,EAAA,6DAAA;EACA,kDAAA;EAEA,6DAAA;AADF;AAEE;EACE,8BAAA;AAAJ;AACI;EACE,mBAAA;EACA,cAAA;EACA,0CAAA;AACN;AACI;EACE,8BAAA;AACN;AACI;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;AACN;AAAM;EACE,8BAAA;EACA,gCAAA;AAER;AAGE;EACE,8BAAA;AADJ;AAEI;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAAN;AAEI;EACE,8BAAA;AAAN;AAEI;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;AAAN;AACM;EACE,8BAAA;EACA,gCAAA;AACR;AAIE;EACE,8BAAA;AAFJ;AAGI;EACE,mBAAA;EACA,cAAA;EACA,0CAAA;AADN;AAGI;EACE,8BAAA;AADN;AAGI;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;AADN;AAEM;EACE,8BAAA;EACA,gCAAA;AAAR;AAKE;EACE,8BAAA;AAHJ;AAII;EACE,mBAAA;EACA,cAAA;EACA,0CAAA;AAFN;AAII;EACE,8BAAA;AAFN;AAII;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;AAFN;AAGM;EACE,8BAAA;EACA,gCAAA;AADR;;AAOA,+CAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6FAAA;EACA,oBAAA;EACA,UAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA,EAAA,0DAAA;EACA,kBAAA;EACA,UAAA;AAJF;AAME;EARF;IASI,kBAAA;EAHF;AACF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;AAHF;;AAMA;EACE,eAAA;EACA,UAAA;EACA,oCAAA;EACA,6BAAA;AAHF;;AAMA,yBAAA;AACA;EACE;IACE,UAAA;IACA,oCAAA;EAHF;EAKA;IACE,UAAA;IACA,oCAAA;EAHF;EAKA;IACE,UAAA;IACA,gCAAA;EAHF;AACF;AAMA;EACE,8EAAA;AAJF;;AAOA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAJF;;AAOA;EACE,qCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,2BAAA;AAJF;;AAOA;EACE,YAAA;EACA,uBAAA;EACA,cAAA,EAAA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,mBAAA,EAAA,uCAAA;EACA,cAAA;AAJF;;AAOA,wBAAA;AACA;EACE,WAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AAJF;;AAOA;EACE,YAAA;EACA,WAAA;EACA,0BAAA;EACA,6BAAA;AAJF;;AAOA,qCAAA;AAEA,sBAAA;AACA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,iFAAA;AALF;;AAQA,sBAAA;AACA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,+EAAA;AALF;;AAQA,uBAAA;AACA;EACE,6CAAA;AALF;;AAQA;EACE,0CAAA;AALF;;AAQA,aAAA;AACA;EACE;IACE,UAAA;IACA,4BAAA;EALF;EAQA;IACE,UAAA;IACA,wBAAA;EANF;AACF;AASA;EACE;IACE,UAAA;IACA,iCAAA;EAPF;EAUA;IACE,UAAA;IACA,6BAAA;EARF;AACF;AAWA,cAAA;AACA;EACE;IACE,UAAA;IACA,wBAAA;EATF;EAYA;IACE,UAAA;IACA,4BAAA;EAVF;AACF;AAaA;EACE;IACE,UAAA;IACA,6BAAA;EAXF;EAcA;IACE,UAAA;IACA,iCAAA;EAZF;AACF","sourcesContent":[".modern-toast {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 30px);\n  min-width: 280px;\n  max-width: 420px;\n  border-radius: 12px;\n  margin: 0;\n  position: relative;\n  overflow: hidden;\n  z-index: 99999 !important;\n\n  /* Premium Light-mode Professional base styling */\n  background: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 16px -6px rgba(0, 0, 0, 0.04);\n  color: #1f2937 !important; /* Dark neutral gray for high-quality corporate readability */\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n\n  /* Specific Action Styles (using subtle professional tints) */\n  &.success {\n    border-left: 4px solid #10b981;\n    .icon-wrap {\n      background: #f0fdf4;\n      color: #10b981;\n      border: 1px solid rgba(16, 185, 129, 0.15);\n    }\n    .progress-fill {\n      background: #10b981 !important;\n    }\n    .btn-ok {\n      background: #10b981 !important;\n      color: #ffffff !important;\n      border: 1px solid #10b981 !important;\n      &:hover {\n        background: #059669 !important;\n        border-color: #059669 !important;\n      }\n    }\n  }\n\n  &.error, &.delete {\n    border-left: 4px solid #ef4444;\n    .icon-wrap {\n      background: #fef2f2;\n      color: #ef4444;\n      border: 1px solid rgba(239, 68, 68, 0.15);\n    }\n    .progress-fill {\n      background: #ef4444 !important;\n    }\n    .btn-ok {\n      background: #ef4444 !important;\n      color: #ffffff !important;\n      border: 1px solid #ef4444 !important;\n      &:hover {\n        background: #dc2626 !important;\n        border-color: #dc2626 !important;\n      }\n    }\n  }\n\n  &.warning {\n    border-left: 4px solid #f59e0b;\n    .icon-wrap {\n      background: #fffbeb;\n      color: #d97706;\n      border: 1px solid rgba(245, 158, 11, 0.15);\n    }\n    .progress-fill {\n      background: #f59e0b !important;\n    }\n    .btn-ok {\n      background: #f59e0b !important;\n      color: #ffffff !important;\n      border: 1px solid #f59e0b !important;\n      &:hover {\n        background: #d97706 !important;\n        border-color: #d97706 !important;\n      }\n    }\n  }\n\n  &.info, &.update {\n    border-left: 4px solid #3b82f6;\n    .icon-wrap {\n      background: #eff6ff;\n      color: #3b82f6;\n      border: 1px solid rgba(59, 130, 246, 0.15);\n    }\n    .progress-fill {\n      background: #3b82f6 !important;\n    }\n    .btn-ok {\n      background: #3b82f6 !important;\n      color: #ffffff !important;\n      border: 1px solid #3b82f6 !important;\n      &:hover {\n        background: #2563eb !important;\n        border-color: #2563eb !important;\n      }\n    }\n  }\n}\n\n/* Glass Overlay gives a premium glossy sheen */\n.glass-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.toast-body {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 14px; /* Reduced mobile height to prevent scroll and look neat */\n  position: relative;\n  z-index: 2;\n\n  @media (min-width: 768px) {\n    padding: 12px 16px;\n  }\n}\n\n.icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  backdrop-filter: blur(5px);\n  flex-shrink: 0;\n}\n\n.icon-wrap ion-icon {\n  font-size: 18px;\n  opacity: 0;\n  transform: scale(0.5) rotate(-30deg);\n  animation-fill-mode: forwards;\n}\n\n/* Icon entry animation */\n@keyframes modernIconPop {\n  0% {\n    opacity: 0;\n    transform: scale(0.5) rotate(-30deg);\n  }\n  60% {\n    opacity: 1;\n    transform: scale(1.15) rotate(10deg);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) rotate(0deg);\n  }\n}\n\n.icon-wrap.animated ion-icon {\n  animation: modernIconPop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n.message-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.message-text {\n  font-size: 0.92rem;\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: 0.1px;\n}\n\n.action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.btn-ok {\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #f3f4f6;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 6px;\n  min-width: 48px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.btn-ok:hover {\n  background: #e5e7eb;\n  color: #111827;\n  transform: translateY(-1px);\n}\n\n.btn-close {\n  border: none;\n  background: transparent;\n  color: #4b5563; /* Darker gray for high visibility */\n  font-size: 1.25rem;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.btn-close:hover {\n  background: #f3f4f6; /* Subtle circular indicator on hover */\n  color: #111827;\n}\n\n/* Subtle Progress Bar */\n.modern-progress-bar {\n  height: 3px;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.04);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n}\n\n.progress-fill {\n  height: 100%;\n  width: 100%;\n  border-radius: 0 4px 4px 0;\n  transition: width 50ms linear;\n}\n\n/* --- Positioning & Animations --- */\n\n/* Desktop top-right */\n.top-right {\n  position: fixed;\n  top: 25px;\n  right: 25px;\n  animation: slideRightBounce 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n/* Mobile top-center */\n.top {\n  position: fixed;\n  top: 25px;\n  left: 50%;\n  transform: translateX(-50%);\n  animation: slideTopBounce 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n/* Closing animations */\n.modern-toast.closing.top-right {\n  animation: fadeOutRight 0.3s forwards ease-in;\n}\n\n.modern-toast.closing.top {\n  animation: fadeOutUp 0.3s forwards ease-in;\n}\n\n/* Slide in */\n@keyframes slideRightBounce {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideTopBounce {\n  0% {\n    opacity: 0;\n    transform: translate(-50%, -50px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n/* Slide out */\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n}\n\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate(-50%, -50px);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
